export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768
export const defaultMenuType = 'menu-default' //'menu-sub-hidden',
// 'menu-hidden'
export const defaultStartPath = '/app/start'
const localhostAddress = 'http://localhost:3000'

const getWelfareUrl = () => {
  let welfareUrl
  let hostname = window.location.hostname
  if (hostname === 'benefits.inbest.ai') {
    welfareUrl = 'https://welfare.inbest.ai/v5'
  } else if (hostname === 'sitbenefits.inbest.ai') {
    welfareUrl = 'https://welfaresit.inbest.ai'
  } else if (hostname === 'benefitsdev.inbest.ai') {
    welfareUrl = 'https://welfaredev.inbest.ai'
  } else if (hostname === 'localhost') {
    welfareUrl = localhostAddress
  } else {
    console.log('Defaulting to production welfare url', hostname)
    welfareUrl = 'https://welfare.inbest.ai/v5'
  }
  if (process.env.API_URL) {
    welfareUrl = process.env.API_URL
  }
  return welfareUrl
}

export const defaultLocale = 'en'
export const localeOptions = [
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Español' }
]
export const welfareAPIUrl = getWelfareUrl()

export const referenceNumberDimensionSpecial = ['auden', 'arbor']
export const isDefined = function (value) {
  return (
    value !== null && value !== '' && value !== undefined && value !== 'null'
  )
}
export const application = 'benefits'
